import {
  EmptyButton,
  EmptyButtonSize,
} from "@smartsuite/react-ui/lib/components/buttons/EmptyButton/EmptyButton";
import {
  RoundButton,
  roundButtonStylesMedium,
} from "@smartsuite/react-ui/lib/components/buttons/RoundButton/RoundButton";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";

export interface PageDesignerFooterProps {
  lastUpdated?: { by: string; on: string };
  onSave: () => Promise<void>;
  onCancel: () => void;
}

export const PageDesignerFooter: React.FC<PageDesignerFooterProps> = ({
  lastUpdated,
  onSave,
  onCancel,
}) => {
  return (
    <div className="page-designer-footer">
      {lastUpdated && (
        <div className="page-designer-footer__info">
          <Text weight="semibold" size="s" color="secondary">
            Last Updated
          </Text>
          <Text weight="regular" size="m" color="secondary">
            by {lastUpdated.by} on {lastUpdated.on}
          </Text>
        </div>
      )}
      <div className="page-designer-footer__actions">
        <EmptyButton size={EmptyButtonSize.LG} onClick={onCancel}>
          Cancel
        </EmptyButton>

        <RoundButton
          styles={roundButtonStylesMedium}
          onClick={() => {
            onSave()
              .then(() => window.parent.postMessage("close", "*"))
              .catch(console.error);
          }}
        >
          Save Design
        </RoundButton>
      </div>
    </div>
  );
};
